<template>
  <div class="calendar">
    <div class="calendar-header"></div>
    <div v-if="isMobile" class="calendar-content is-mobile">
      <van-collapse v-model="activeNames" :border="false" :class="expand && 'is-expand'" @change="handleChange">
        <van-collapse-item name="dayTable" :border="false">
          <template #title>
            <div class="month" @click.stop>
              <div class="prev-btn el-icon-arrow-left icon-btn" :class="isCurrentYearMonth && 'is-disabled'" @click="prevMonth"></div>
              <div class="label">{{ monthLabel }}</div>
              <div class="next-btn el-icon-arrow-right icon-btn" @click="nextMonth"></div>
            </div>
          </template>
          <el-table
            class="day-table"
            :data="calendarDays"
          >
            <el-table-column
              v-for="(week, index) in weekList"
              align="center"
              :width="tableCellWidth"
              :prop="week.data"
              :key="index"
              :label="week.label"
            >
              <template #default="{ row }">
                <div
                  v-if="row[week.data]" class="day-content"
                  :class="[isSelectedDate(row[week.data]) && 'is-selected', isDisabledDay(row[week.data]) && 'is-disabled']"
                  @click="handleSelectDate(row[week.data])"
                >
                  <span class="day-label">{{row[week.data]}}</span>
                  <div v-if="isSelectedInterviewDate(row[week.data])" class="dot"></div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <slot name="dayTableExtra"/>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else class="calendar-content">
      <div class="month">
        <div class="prev-btn el-icon-arrow-left icon-btn" :class="isCurrentYearMonth && 'is-disabled'" @click="prevMonth"></div>
        <div class="label">{{ monthLabel }}</div>
        <div class="next-btn el-icon-arrow-right icon-btn" @click="nextMonth"></div>
      </div>
      <el-table
        class="day-table"
        :data="calendarDays"
      >
        <el-table-column
          v-for="(week, index) in weekList"
          align="center"
          :width="tableCellWidth"
          :prop="week.data"
          :key="index"
          :label="week.label"
        >
          <template #default="{ row }">
            <div
              v-if="row[week.data]" class="day-content"
              :class="[isSelectedDate(row[week.data]) && 'is-selected', isDisabledDay(row[week.data]) && 'is-disabled']"
              @click="handleSelectDate(row[week.data])"
            >
              <span class="day-label">{{row[week.data]}}</span>
              <div v-if="isSelectedInterviewDate(row[week.data])" class="dot"></div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="calendar-footer"></div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    selectedDate: {
      type: String,
      required: true
    },
    selectedInterviewDateList: {
      type: Array,
      default: () => ([])
    },
    tableCellWidth: {
      type: String,
      default: '36px'
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'selectedDate',
    event: 'change'
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      year: null,
      month: null,
      calendarDays: [],
      calendarDate: moment(),
      currentDate: moment(),
      activeNames: ['dayTable'],
      expand: true
    }
  },
  computed: {
    weekList () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.week.sun`),
          data: 'sun'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.mon`),
          data: 'mon'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.tue`),
          data: 'tue'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.wed`),
          data: 'wed'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.thu`),
          data: 'thu'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.fri`),
          data: 'fri'
        },
        {
          label: this.$t(`${this.i18nPrefix}.week.sat`),
          data: 'sat'
        }
      ]
    },
    monthLabel () {
      return this.calendarDate.format('MMMM YYYY')
    },
    isCurrentYearMonth () {
      return this.currentDate.year() === this.calendarDate.year() && this.currentDate.month() === this.calendarDate.month()
    }
  },
  created () {
  },
  mounted () {
    this.refreshCalendarDays()
  },
  methods: {
    handleChange (activeNames) {
      if (activeNames.length === 0) {
        this.expand = false
      } else {
        setTimeout(() => {
          this.expand = true
        }, 300)
      }
    },
    refreshCalendarDays () {
      const weekGroups = []
      const totalDays = this.calendarDate.daysInMonth()
      const dataKeyMap = {
        0: 'sun',
        1: 'mon',
        2: 'tue',
        3: 'wed',
        4: 'thu',
        5: 'fri',
        6: 'sat'
      }
      let weekValue = {}
      _.forEach(_.range(1, totalDays + 1), day => {
        const calendarDate = this.calendarDate.clone().date(day)
        const weekNum = calendarDate.day()
        const dataKey = dataKeyMap[weekNum]
        weekValue[dataKey] = day
        if (dataKey === 'sat') {
          weekGroups.push(_.clone(weekValue))
          weekValue = {}
        }
      })
      if (!_.isEmpty(weekValue)) {
        weekGroups.push(weekValue)
      }
      this.calendarDays = weekGroups
    },
    handleSelectDate (day) {
      if (this.isDisabledDay(day)) {
        return
      }
      this.$emit('change', this.calendarDate.clone().date(day).format('YYYY-MM-DD'))
    },
    prevMonth () {
      if (this.isCurrentYearMonth) {
        return
      }
      this.calendarDate = this.calendarDate.clone().subtract(1, 'month')
      this.refreshCalendarDays()
    },
    nextMonth () {
      this.calendarDate = this.calendarDate.clone().add(1, 'month')
      this.refreshCalendarDays()
    },
    isSelectedInterviewDate (day) {
      const date = this.calendarDate.clone().date(day)
      return _.some(this.selectedInterviewDateList, interviewDate => {
        return date.isSame(interviewDate, 'day')
      })
    },
    isSelectedDate (day) {
      if (!this.selectedDate) {
        return
      }
      const date = this.calendarDate.clone().date(day)
      return moment(this.selectedDate).isSame(date, 'day')
    },
    isDisabledDay (day) {
      const date = this.calendarDate.clone().date(day)
      return date.isBefore(this.currentDate, 'day')
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler () {
        const locale = this.$i18n.locale
        if (locale === 'en') {
          moment.locale('en')
        } else {
          moment.locale('zh-cn')
        }
        this.calendarDate = moment()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.calendar {
  .calendar-content {
    .month {
      padding: 0 32px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      line-height: 20px;
      color: #000;
      font-size: 14px;

      .icon-btn {
        font-size: 14px;
        color: #0096cc;
        cursor: pointer;

        &.is-disabled {
          color: #c2c5cb;
          cursor: not-allowed;
        }
      }
    }

    .day-table {
      margin-top: 14px;
      color: #000;

      .day-content {
        margin: 0 auto;
        position: relative;
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 50%;
        transition: background-color 0.25s ease;

        &.is-selected {
          background: rgba(0, 150, 204, 0.1);

          .day-label {
            color: #0096cc;
          }
        }

        &.is-disabled {
          cursor: not-allowed;
          color: #c0c4cc;

          &:hover {
            background-color: #f5f5f5;
          }
        }

        &:hover {
          background-color: rgba(0, 150, 204, 0.1);
        }

        .day-label {
          line-height: 20px;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #0096cc;
          position: absolute;
          bottom: 3px;
          border-radius: 50%;
        }
      }

      &::before {
        display: none;
      }

      ::v-deep {
        .el-table__header-wrapper {
          .el-table__header {
            thead {
              color: #000;
            }

            .el-table__cell {
              font-size: 12px;
            }
          }
        }

        .el-table__body-wrapper {
          .el-table__body {
            .el-table__row {
              &:hover {
                .el-table__cell {
                  background-color: #fff;
                }
              }
            }
          }
        }

        td, th {
          &.el-table__cell {
            border-bottom-width: 0;
            padding: 0;
            font-weight: 400;

            .cell {
              padding: 0;
              line-height: 20px;
            }
          }
        }
      }
    }

    &.is-mobile {
      .van-collapse-item {
        ::v-deep {
          .van-collapse-item__title {
            background: rgba(171, 171, 171, 0.2);
            border-radius: 2px;

            .van-cell__title {
              line-height: 20px;
            }

            .van-cell__right-icon {
              height: 20px;
              line-height: 20px;
            }
          }

          .van-collapse-item__wrapper {
            .van-collapse-item__content {
              padding: 0;
            }
          }
        }
      }

      .is-expand {
        ::v-deep {
          .van-collapse-item__wrapper {
            overflow: initial;
          }
        }
      }

      .month {
        padding: 0;
        margin-left: 60px;
        margin-right: 20px;
      }

      .day-table {
        width: 294px;
        margin: 14px auto 0;

        .day-content {
          &.is-disabled {
            &:hover {
              background-color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
